const MuiTypography = {
  defaultProps: {
    variant: "bodyDefault",
    variantMapping: {
      d1: "div",
      d2: "div",
      d3: "div",
      d4: "div",
      d5: "div",
      d6: "div",
      bodyXLarge: "p",
      bodyLarge: "p",
      bodyDefault: "p",
      bodySmall: "p",
      bodyXSmall: "p",
      arrow: "div"
    }
  },
  variants: [
    {
      props: { variant: "arrow" },
      style: {
        "&:after": {
          content: '"\\00a0»"'
        }
      }
    }
  ]
};
export {
  MuiTypography
};
//# sourceMappingURL=MuiTypography.js.map
